import {createSlice, PayloadAction, Reducer} from '@reduxjs/toolkit'
import {updateObject} from '../utils/utility';

const initialState = {
    language: 'de',
};

export const settingSlice = createSlice({
    name: 'setting/get',
    initialState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
        setLanguage: (state, action: PayloadAction<string>) => {
            localStorage.setItem("userLanguage", action.payload);
            return updateObject(state, {language: action.payload})
        },
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
    }
})

export const {setLanguage} = settingSlice.actions;
export const settingReducer: Reducer<typeof initialState> = settingSlice.reducer;
